interface WhatsAppIconProps {
  className?: string;
  size?: number;
}

/**
 * Official WhatsApp glyph rendered as inline SVG with a white outline.
 * Use on colored backgrounds (e.g. WhatsApp green CTAs).
 */
const WhatsAppIcon = ({ className, size = 20 }: WhatsAppIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="#25D366"
      stroke="#ffffff"
      strokeWidth="1.8"
      strokeLinejoin="round"
      d="M16 3C8.82 3 3 8.82 3 16c0 2.29.6 4.43 1.65 6.29L3 29l6.88-1.62A12.93 12.93 0 0 0 16 29c7.18 0 13-5.82 13-13S23.18 3 16 3z"
    />
    <path
      fill="#ffffff"
      d="M22.5 19.4c-.35-.18-2.07-1.02-2.39-1.14-.32-.12-.55-.18-.78.18-.23.35-.9 1.14-1.1 1.37-.2.23-.4.26-.75.09-.35-.18-1.48-.55-2.82-1.74-1.04-.93-1.74-2.07-1.95-2.42-.2-.35-.02-.54.15-.71.16-.16.35-.4.53-.61.18-.2.23-.35.35-.58.12-.23.06-.44-.03-.61-.09-.18-.78-1.88-1.07-2.58-.28-.68-.57-.59-.78-.6-.2-.01-.44-.01-.67-.01-.23 0-.61.09-.93.44-.32.35-1.21 1.18-1.21 2.88s1.24 3.34 1.41 3.57c.18.23 2.44 3.73 5.92 5.23.83.36 1.47.57 1.97.73.83.26 1.58.22 2.18.13.66-.1 2.07-.85 2.36-1.66.29-.81.29-1.51.2-1.66-.09-.15-.32-.23-.67-.41z"
    />
  </svg>
);

export default WhatsAppIcon;
